import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { upiDetailsType } from "../../../types/paymentType";

const initialState: upiDetailsType = {
  isVerified: undefined,
  upi_id: "",
  error: { error: "", success: "", userName: "" },
};

const upiSlice = createSlice({
  name: "upi",
  initialState,
  reducers: {
    setUpiId: (state, action: PayloadAction<string>) => {
      state.upi_id = action.payload;
    },
    setIsVerified: (state, action: PayloadAction<boolean>) => {
      state.isVerified = action.payload;
    },
    setError: (
      state,
      action: PayloadAction<{
        error: string;
        success: string;
        userName: string;
      }>
    ) => {
      state.error = action.payload;
    },
    resetUpiState: () => initialState,
  },
});

export const { setUpiId, setIsVerified, setError, resetUpiState } =
  upiSlice.actions;
export default upiSlice.reducer;
